export const SET_USER_AUTH_TOKENS = 'SET_USER_AUTH_TOKENS'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_USER_AUTENTICATED = 'SET_USER_AUTENTICATED'
export const SET_USER_TYPE = 'SET_USER_TYPE'
export const REMOVE_COOKIE = 'REMOVE_COOKIE'
export const LOGOUT = 'LOGOUT'
